<div>
    <asset-basic-info [asset]="asset"></asset-basic-info>
    <asset-premiums [asset]="asset" (validated)="onPremiumsValidated($event)"></asset-premiums>
</div>
